<template>
	<div  :aria-busy="loading ? 'true' : 'false'">
		<section class="content__custom" v-if="!loading">
			<div class="main-title" v-if="recipient.name">
				<h1 class="followers">
					{{ recipient.name }}
				</h1>
			</div>

			<div class="boxes" v-if="recipient.name">
				<div class="box">
					<div class="box__container">
						<div class="box__body">
							<table class="table--fixed">
								<thead>
									<tr>
										<th class="name-cell">{{ 'name' | translate | titleCase }}</th>
										<th class="email-cell">{{ 'email' | translate | titleCase }}</th>
										<th class="phone-cell">{{ 'phone' | translate | titleCase }}</th>
										<th class="platform-cell">{{ 'network' | translate | titleCase }}</th>
										<th class="date-cell">{{ 'date-of-interaction' | translate | titleCase }}</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td :title="'name' | translate" class="name-cell">{{ recipient.name }}</td>
										<td :title="'email' | translate" class="email-cell">{{ recipient.email }}</td>
										<td :title="'phone' | translate" class="intention-cell">{{ recipient.cellphone }}</td>
										<td :title="'network' | translate" class="platform-cell"><i v-if="recipient.platform == 'facebook'" class="fas fa-facebook"></i><i v-if="recipient.platform == 'twitter'" class="fas fa-twitter"></i></td>
										<td :title="'first-interaction' | translate" class="date-cell">{{ recipient.created_at | date }}</td>
									</tr>
								</tbody>
							</table>

							<div v-if="recipient.groups.length >= 1">
								<h2 class="box__title">{{ 'groups' | translate }}</h2>
								<ul class="tags" v-if="recipient.groups">
									<li class="tags__tag" v-for="group in recipient.groups" :key="group.id">
										<router-link :to="'/grupos/editar/' + (group.id)">{{ group.name }}</router-link>
									</li>
								</ul>
							</div>
							<div v-if="recipient.intents.length >= 1">
								<h2 class="box__title">{{ 'themes' | translate }}</h2>
								<ul class="tags" v-if="recipient.intents">
									<li class="tags__tag" v-for="intents in recipient.intents" :key="intents.id">
										<router-link :to="'tema?id=' + (intents.id)">{{ intents.tag }}</router-link>
									</li>
								</ul>
							</div>
						</div>
						<!-- <div class="box__body">
							<ul>
								<li @click="$router.go(-1)">
									<button type="button" @click="replyMessage()">
										{{ 'back' | translate | uppercase }}
									</button>
								</li>
							</ul>
						</div> -->
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
export default {
	name: 'details-supporters',
	data() {
		return {
			loading: false,
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
				recipientId: this.$route.query.id,
			},
		};
	},
	computed: {
		recipient() {
			return this.$store.state.recipient.recipient;
		},
	},
	methods: {
		toggleLoading() {
			this.loading = !this.loading;
		},
	},
	mounted() {
		this.toggleLoading();
		this.$store.dispatch('getSupporter', this.session)
			.then(() => {
				this.toggleLoading();
			})
			.catch(() => {
				this.toggleLoading();
			});
	},
};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/recipient/supportersDetails.vue